<template>
  <div class="animated fadeIn">
    <b-container fluid class="order-list">
      <b-card header-bg-variant="primary" border-variant="primary" header="Filtros">
        <b-row>
          <b-col xl="4">
            <b-form-group
              label="Busqueda"
              class="mb-0"
              :invalid-feedback="!isValidText(filter, false)? 'No es un valor válido' : ''"
              :state="isValidText(filter, false)"
              description="Ingrese el texto a buscar en cliente o número">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Texto a buscar" />
                <b-input-group-button>
                  <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                </b-input-group-button>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col xl="3" v-show="liquidationReport !== true">
            <b-form-group label="Estado" class="mb-3" description="Seleccione el estado del pedido">
              <b-form-select :options="statusMapping" v-model="statusName">
                <option slot="first" :value="null">Todos</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="liquidationReport !== true">
          <b-col xl="6" text-right>
            <b-form-group 
              label="Filtrar por TAGS"
              description="Selecciones los tags de ordenes que desea filtrar en la busqueda"
              >
               <b-form-checkbox-group v-model="filterTags" stacked>
                  <template v-for="tagElem in tagsMapping">
                    <b-form-checkbox 
                      v-if="!tagElem.isCt"
                      :key="tagElem.key"
                      :value="tagElem.key"
                    >
                      <span class="tag-check p-1" :class="tagElem.bg">{{tagElem.text}}</span>
                    </b-form-checkbox>
                  </template>
                </b-form-checkbox-group>
              </b-form-group>
          </b-col>
          <b-col xl="6">
              <b-button class="float-right mr-2" :disabled="loading || disableFilter" variant="primary" @click.stop="filterTable" >Filtrar</b-button>
              <b-button class="float-right mr-2"  :disabled="loading || disableFilter" variant="primary" @click.stop="exportCSV" >Exportar CSV</b-button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <b-button class="float-right mr-2" :disabled="loading || disableFilter" variant="primary" @click.stop="filterTable" >Filtrar</b-button>
            <b-button class="float-right mr-2" variant="primary" @click.stop="exportCSV" >Exportar CSV</b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-row class="mt-3">
        <b-col class="col-md-auto">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mb-3" />
        </b-col>
        <b-col class="col-md-auto per-page">
          <b-form-group id="perPage" horizontal label="Mostrar por página">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col md="12">
          <b>{{totalRows}}</b> {{liquidationReport? totalRows > 1? 'liquidaciones encontradas' : 'liquidacion encontrada' : totalRows > 1? 'Pedidos encontrados' : 'Pedido encontrado'}}
        </b-col>
      </b-row>
      <b-card header-bg-variant="primary" border-variant="primary" :header="liquidationReport ? 'Liquidaciones' : 'Listado de pedidos'">
        <moon-loader :loading="loading" color="#000" size="30px"></moon-loader>
        <b-table v-show="!loading" id="mainTable"
          ref="mainTable"
           show-empty
           striped
           hover
           stacked="xl"
           :items="itemProvider"
           foot-clone
           :fields="isAdmin ? fields: fieldsNotAdmin"
           :current-page="currentPage"
           :per-page="perPage"
           :sort-by.sync="sortBy"
           :sort-desc.sync="sortDesc"
           @row-clicked="rowClick"
           @filtered="onFiltered"
           empty-text="No hay pedidos para mostrar"
           empty-filtered-text="No hay pedidos para mostrar">
          <template slot="clientProfileData" slot-scope="data">
            {{data.value ? data.value.firstName : ''}} {{data.value ? data.value.lastName : ''}}
          </template>
          <template slot="liquidationDate" slot-scope="row">
            {{new Date(row.item.liquidated.date).toLocaleDateString(locale)}}
          </template>
          <template slot="invoiceNumber" slot-scope="row">
            {{row.item.liquidated.invoiceNumber}}
          </template>
          <template slot="liquidationValue" slot-scope="row">
            {{currency}} {{row.item.liquidated.value}}
          </template>
          <template slot="value" slot-scope="value">
            {{currency}} {{value.value}}
          </template>
          <template slot="status" slot-scope="status">
            <span :class="getStatusColorClass(status.value)"><b>{{statusMapping[status.value]}}</b></span>
          </template>
          <template slot="creationDate" slot-scope="creationDate">
            {{new Date(creationDate.value).toLocaleDateString(locale)}}
          </template>
          <template slot="tags" slot-scope="row">
            <span
              v-for="tagElemKey in row.item.tags"
              v-b-tooltip.hover
              :title="tagsMapping[tagElemKey].description"
              class="tag"
              :class="tagsMapping[tagElemKey].bg"
            >
              {{tagElemKey}}
            </span>
          </template>
          <template slot="action" slot-scope="row">
            <b-button size="sm" variant="link" @click.stop="row.toggleDetails" v-show="showPromoDetail(row.item.items)">
              <span v-show="!row.detailsShowing"><i class="fa fa-plus"></i></span>
              <span v-show="row.detailsShowing"><i class="fa fa-minus"></i></span>
              {{ row.detailsShowing ? 'Ocultar' : 'Ver'}} promociones
            </b-button>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-row>
              <!-- Order row details -->
                <b-col md="12">
                  <b-card>
                    <div v-for="item in row.item.items" :key="item.id">
                      <h5>Producto: {{item.name}} (sku: {{item.id}})</h5>
                      <b-table
                          striped
                          :items="item.priceTags"
                          hover
                          outlined
                          head-variant='light'
                          :fields="promotionFields"
                          :small="true">
                      </b-table>
                    </div>
                  </b-card>
                </b-col>
            </b-row>
          </template>
        </b-table>
      </b-card>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {OrdersServiceMixim} from '@/mixims/OrdersServiceMixim.js'
import appConfig from '@/config/applicationConfig.js'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import {CsvReportExportMixim} from './CsvReportExportMixim.js'
import { ValidationsMixim } from '@/mixims/ValidationsMixim.js'

export default {
  name: 'orders-report',
  mixins: [OrdersServiceMixim, CsvReportExportMixim, ValidationsMixim],
  components: {MoonLoader},
  props: ['rangeDate', 'account', 'liquidationReport'],
  watch: {
    rangeDate: function (val, oldVal) {
      if (!val || !Array.isArray(val) || val.length < 2) {
        this.fromDate = null
        this.toDate = null
        return
      }
      this.fromDate = val[0]
      this.toDate = val[1]
      this.$refs.mainTable.refresh()
    },
    account: function (val, oldVal) {
      this.$refs.mainTable.refresh()
    }
  },
  data () {
    return {
      fields: !this.liquidationReport ? [
        { key: 'id', label: 'Número', 'class': 'text-left', sortable: true },
        { key: 'accountName', label: 'Seller', 'class': 'text-left', sortable: true },
        { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true },
        { key: 'creationDate', label: 'Fecha', 'class': 'text-left', sortable: true },
        { key: 'value', label: 'Total', 'class': 'text-left', sortable: true },
        { key: 'status', label: 'Estado', 'class': 'text-left', sortable: true },
        { key: 'tags', label: 'Etiquetas', 'class': 'text-left' },
        { key: 'action', label: ' ', 'class': 'text-right', sortable: false }
      ] : [
        { key: 'id', label: 'Número', 'class': 'text-left', sortable: true },
        { key: 'accountName', label: 'Seller', 'class': 'text-left', sortable: true },
        { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true },
        { key: 'liquidationDate', label: 'Fecha de liquidacion', 'class': 'text-left', sortable: false },
        { key: 'invoiceNumber', label: 'Factura', 'class': 'text-left', sortable: false },
        { key: 'liquidationValue', label: 'Monto de liquidacion', 'class': 'text-left', sortable: false }

      ],
      fieldsNotAdmin: !this.liquidationReport ? [
        { key: 'id', label: 'Número', 'class': 'text-left', sortable: true },
        { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true },
        { key: 'creationDate', label: 'Fecha', 'class': 'text-left', sortable: true },
        { key: 'value', label: 'Total', 'class': 'text-left', sortable: true },
        { key: 'status', label: 'Estado', 'class': 'text-left', sortable: true },
        { key: 'tags', label: 'Etiquetas', 'class': 'text-left', sortable: false },
        { key: 'action', label: ' ', 'class': 'text-right', sortable: false }
      ] : [
        { key: 'id', label: 'Número', 'class': 'text-left', sortable: true },
        { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true },
        { key: 'liquidationDate', label: 'Fecha de liquidacion', 'class': 'text-left', sortable: false },
        { key: 'invoiceNumber', label: 'Factura', 'class': 'text-left', sortable: false },
        { key: 'liquidationValue', label: 'Monto de liquidacion', 'class': 'text-left', sortable: false }
      ],
      promotionFields: [
        { key: 'description', label: 'Nombre', formatter: (value) => { return value === null ? 'Promo Ecommerce' : value } },
        { key: 'promotionUserType', label: 'Usuario', formatter: (value) => { return value === null ? 'ECOMMERCE' : value } },
        { key: 'rawValue', label: 'Descuento', formatter: (value, key, item) => { return item.isPorcentual ? `${value}%` : `${this.currency} ${value}` } },
        { key: 'value', label: 'Total descuento', 'class': 'text-right', formatter: (value) => { return `${this.currency} ${value}` } }
      ],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [ 10, 15, 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      locale: appConfig.LOCALE,
      currency: appConfig.CURRENCY,
      filterTags: [],
      statusName: null,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      statusMapping: appConfig.STATUS_MAPPING,
      statusMappingColors: appConfig.STATUS_MAPPING_COLORS,
      tagsMapping: appConfig.TAGS_MAPPING,
      showFilters: true,
      tableComponentInfo: null
    }
  },
  computed: {
    disableFilter () {
      if (this.isEmptyData(this.filter) && this.liquidationReport) {
        return true
      }

      if (!this.isValidText(this.filter)) {
        return true
      }
      return false
    },
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
    getStatusColorClass: function (status) {
      return 'text-' + this.statusMappingColors[status] + ' h6'
    },
    rowClick (item) {
      this.$router.push(`/orders/orderDetail/${item.id}`)
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    filterTable () {
      this.$refs.mainTable.refresh()
    },
    exportCSV () {
      this.loading = true
      this.$emit('error', '')
      return this.getAllOrders(this.tableComponentInfo, true).then(
        (csvFile) => {
          let filename = this.filterTags.indexOf('LQ') !== -1 ? 'liquidatedReportCSV.csv' : 'orderReportCSV.csv'
          this.loading = false
          this._exportCSV(csvFile, filename)
        },
        (error) => {
          this.loading = false
          let errorText = error.body.message || 'Error obteniendo el reporte de pedidos'
          this.$emit('error', errorText)
        }
      )
    },
    itemProvider (tableComponentInfo) {
      this.loading = true
      // is the component in liquidated report tab
      // so, the filters will be set to get only liquidated orders.
      if (this.liquidationReport) {
        this.filterTags = ['LQ']
      }
      this.$emit('error', '')
      this.tableComponentInfo = tableComponentInfo
      console.log(this.filters)
      return this.getAllOrders(tableComponentInfo).then(
        (response) => {
          let items = response.body
          this.totalRows = parseInt(response.headers.get('X-Total-Count'))
          this.loading = false
          return items
        },
        (error) => {
          this.loading = false
          let errorText = error.body.message || 'Error obteniendo el reporte de pedidos'
          this.$emit('error', errorText)
          return []
        }
      )
    },
    showPromoDetail (arrDetails) {
      let showDetail = false
      arrDetails.forEach(itemDetail => {
        if (itemDetail.priceTags) {
          showDetail = true
        }
      })
      return showDetail
    }
  }
}
</script>

<style lang="scss" scoped>
  .order-list {
    .orderTable {
      table-layout: fixed;
    }

    .btn-link {
      color: #666666;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }

    .filter-row {
      .btn-primary {
        width: 80px;
      }

      button {
        i {
          margin-right: 5px;
        }
      }
    }

    .filters {
      border: 1px solid #e3e8ec;
      background-color: #FFF
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .tag {
      width: 26px;
      display: inline-block;
      border-radius: 5px;
      line-height: 17px;
      margin-right: 4px;
      cursor: pointer;
      text-align: center;
    }

    tr:hover {
      cursor: pointer
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/reports/OrdersReport.vue